import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ENV_CONFIG } from '@ps/core-config';
import { OperatorUserListResponseDto } from './dtos/company.dto';
import { OperatorUserMapper } from './mappers/operator-user.mapper';
import { CompanyOperatorUser } from '../models/company.model';

@Injectable({ providedIn: 'root' })
export class OperatorUserApi {
  private readonly _httpClient = inject(HttpClient);
  private readonly _environmentConfig = inject(ENV_CONFIG);
  private readonly _baseUrl = this._environmentConfig.pureSpectrum.url;
  private readonly _mapper = new OperatorUserMapper();

  public operatorUsers(): Observable<CompanyOperatorUser[]> {
    return this._httpClient
      .get<OperatorUserListResponseDto>(`${this._baseUrl}/operator-users`)
      .pipe(map((response) => this._mapper.fromDtoList(response.users)));
  }
}
